module.exports = __webpack_public_path__ + "static/media/cart.d47dc684.svg";